"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertStylesObjToString = void 0;
const universal_utils_1 = require("@ecocart/universal-utils");
const convertStylesObjToString = (styleObj) => Object.entries(styleObj)
    .map(([key, value]) => (value != undefined || value !== '' ? `${(0, universal_utils_1.pascalToKebab)(key)}:${value}` : undefined))
    .filter(Boolean)
    .join(';');
exports.convertStylesObjToString = convertStylesObjToString;
